import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Merchant from 'containers/merchant'
import Client from 'containers/client'
import MerchantAcl from 'acl/MerchantAcl';
import ClientAcl from 'acl/ClientAcl';
import Login from 'forms/auth/login';
import Register from 'forms/auth/register';
import NotFound from './404'
import ErrorBoundary from './error-boundary'

const AuthRoutes = () => (
  <ErrorBoundary>
    <Switch>
      <Route path={`/login`} exact component={Login} />
      <Route path={`/register`} exact component={Register} />
      <MerchantAcl path="/merchant" component={Merchant} />
      <ClientAcl path="/client" component={Client} />
      <Route component={NotFound} />
    </Switch>
  </ErrorBoundary>
);


export default AuthRoutes
